export default __webpack_public_path__ + "static/media/ConNub.ab83a3c3.png";